import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

import { components } from 'react-select';

export default function SearchValueContainer({ children, ...props }) {
  return (
    <components.ValueContainer {...props}>
      <FontAwesomeIcon className="ml-2 text-primary position-absolute" icon={faSearch} />
      {children}
    </components.ValueContainer>
  );
}

SearchValueContainer.propTypes = {
  children: PropTypes.node
};

const offsetStyles = { marginLeft: 16 };
SearchValueContainer.styleOverrides = {
  input: offsetStyles,
  placeholder: offsetStyles,
  singleValue: offsetStyles,
};

